import { observer } from "mobx-react";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import { BUTTON_VARIANTS } from "../../../../../../components/inputs/button-variants";
import { Button } from "../../../../../../components/inputs/button/button";
import { Input } from "../../../../../../components/inputs/input/input";
import './value-range.scss';



interface IValueRangeProps {
    from: {
        value?: number,
        default: number,
        callback: (v: number) => void,
    },
    to: {
        value?: number,
        default: number,
        callback: (v: number) => void,
    },
    units?: string,
    defaultLabel?: string,
    disabled?: boolean,
}

const ValueRange: React.FC<IValueRangeProps> = observer(({
    from,
    to,
    units = '%',
    defaultLabel = 'Default',
    disabled = false
}) => {
    return (
        <div className="value-range">
            <Input
                value={from.value}
                onChange={(v) => from.callback(v as number)}
                disabled={disabled}
            />
            <FontBody1 color={FONT_COLOR.PRIMARY2} >-</FontBody1>
            <Input
                value={to.value}
                onChange={(v) => to.callback(v as number)}
                disabled={disabled}
            />
            <div className="range-units">
                <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY3_50}>{units}</FontBody1>
            </div>
            <Button
                variant={BUTTON_VARIANTS.Text}
                onClick={() => {
                    if (from.value !== from.default || to.value !== to.default) {
                        from.callback(from.default);
                        to.callback(to.default);
                    }
                }}
                text={defaultLabel}
            />
        </div>
    )
});

export default ValueRange;